class TableUtilManager {
    removeAllByKeys(o) {
        for (let key in o) {
            delete o[key];
        }
    }

    isNOU(v) {
        return v === undefined || v === null;
    }

    isEmpty(arr) {
        return this.isNOU(arr) || !Array.isArray(arr) || arr.length === 0;
    }

    extractLocale(locale) {
        const languageMatch = /^\w{2}/.exec(locale);
        const countryMatch = /\w{2}$/.exec(locale);
        return {
            languageCode: languageMatch ? languageMatch[0] : null,
            countryCode: countryMatch ? countryMatch[0] : null,
        }
    }

    getImgUrl(src) {
        return require('@/assets/image/' + src);
    }

    getUniqueId() {
        return Math.random().toString(36).substr(2, 9);
    }

    trimAllSpaces(str) {
        try {
            if (this.isNOU(str)) return null;
            if (typeof str === 'number') {
                str = "" + str;
            } else if (typeof str !== 'string') {
                throw new Error("trim params s should be string, str is " + str);
            }
            return str.split(' ').join('');
        } catch (err) {
            console.error('PrinterModal trimAllSpaces Error! ' + err);
            return '';
        }
    }

    trim(s) {
        if (this.isNOU(s)) return null;
        if (typeof s !== 'string') {
            throw new Error("trim params s should be string");
        }
        return s.trim();
    }

    searchByKeyword(obj, keyword, keyArr) {
        if (!obj) throw new Error("obj must be Object");
        if (!keyword || !this.trimAllSpaces(keyword)) return true;
        if (this.isEmpty(keyArr)) throw new Error("keyArr must be array and not empty");
        for (let i = 0; i < keyArr.length; i++) {
            const key = keyArr[i];
            const str = this.byString(obj, key);
            if (!str || !this.trimAllSpaces(str)) continue;
            if (this.trimAllSpaces(str).toLowerCase().indexOf(this.trimAllSpaces(keyword).toLowerCase()) > -1) return true;
        }
        return false;
    }

    /**
     * 첫 번째 인자로 넘어온 Object 에서 s 키의 값을 반환합니다.
     * 
     * @param o
     * @param s
     * @returns {null|*}
     */
    byString(o, s) {
        if (!s) return null;
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        let a = s.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
            let k = a[i];
            if (!this.isNOU(o[k]) && k in o) {
                o = o[k];
            } else {
                return null;
            }
        }
        return o;
    }

    /**
     * 첫 번째 인자로 넘어온 Object 에 s 키에 v 의 값을 대입합니다.
     *
     * @param o
     * @param s
     * @returns {null|*}
     */
    assign(o, s, v) {
        if (!s) return null;
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        let a = s.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
            let k = a[i];
            if (k in o) {
                if (i < (n - 1)) {
                    o = o[k];
                } else {
                    o[k] = v;
                    o = o[k];
                }
            } else {
                return null;
            }
        }
        return o;
    }
}

const tableUtilManager = new TableUtilManager();

export default tableUtilManager;